module.exports = __webpack_public_path__ + "img/geo-zones-4-mobile.cbbc224f.gif";